import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  return (
    <>
      <IconButton
        size="large"
        aria-label="language switcher"
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleMenu}
        sx={{
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          color: '#ffffff',
          width: 48,
          height: 48,
          transition: 'all 0.3s ease',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.2)',
            transform: 'scale(1.1)',
          },
          '@media (max-width: 600px)': {
            width: 40,
            height: 40,
          },
        }}
      >
        <LanguageIcon sx={{ color: '#ffffff' }} />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => changeLanguage('en')}>
          <ListItemIcon>
            <span role="img" aria-label="English">🇬🇧</span>
          </ListItemIcon>
          <ListItemText>English</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('so')}>
          <ListItemIcon>
            <span role="img" aria-label="Somali">🇸🇴</span>
          </ListItemIcon>
          <ListItemText>Somali</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher; 